import Vue from "vue";
import App from "./App.vue";
import VueAxios from "vue-axios";
import axios from "axios";

import "./registerServiceWorker";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import routes from "./routes";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { store } from "./store";
import VueEditableGrid from "vue-editable-grid";
import "vue-editable-grid/dist/VueEditableGrid.css";
import Auth0Authenticate from "./callia-auth0-authenticate";
import CalliaAxio from "./callia-axios";
import TooltipModal from "./components/tooltip-modal.vue";

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 401:
          console.log("Token expired or unauthorized, redirecting to login");
          // Clear any cached auth data
          localStorage.clear();
          sessionStorage.clear();
          // Redirect to login page
          window.location.href = "/login";
          break;
        default:
          console.log(`connection error ${error.response.status}`);
      }
    } else {
      console.log("error: ", error);
    }
    return Promise.resolve(error.response);
  }
);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueEditableGrid);
Vue.use(VueAxios, axios);
Vue.use(Auth0Authenticate, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  redirectUri: `${window.location.origin}`,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  // `offline_access` makes Auth0 issue a refresh token.
  scope: "openid profile email offline_access",
  // Renew the access token via a (rotating) refresh token instead of silent
  // iframe auth — keeps the session alive and avoids `consent_required`.
  useRefreshTokens: true,
  // Required so the refresh token survives page reloads.
  cacheLocation: "localstorage",
  logoutRedirectUri: `${window.location.origin}`
});
Vue.component("tooltip-modal", TooltipModal);
Vue.use(CalliaAxio, axios, true);
Vue.config.productionTip = false;
const router = routes;
// NOTE: the cross-component event bus now lives in `src/services/event-bus.js`
// (a framework-agnostic emitter) instead of a `new Vue()` instance, which is
// not an event emitter in Vue 3. Import it from there, not from this file.

// Initialize Auth0 and mount app
(async () => {
  const app = new Vue({
    router,
    store,
    render: h => h(App)
  });

  // Initialize Auth0 client
  await app.$auth.init();

  app.$mount("#app");
})();
